var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoltslash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 75.9300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5898 6.10352L64.502-38.916C65.1855-39.8438 65.5762-40.6738 65.5762-41.6016C65.5762-43.3594 64.209-44.6289 62.4512-44.6289L40.918-44.6289L52.2461-73.9746C53.9062-78.418 49.1699-80.8594 46.3379-77.1973L11.4258-32.1777C10.7422-31.25 10.3516-30.4199 10.3516-29.4922C10.3516-27.7344 11.6699-26.4648 13.4766-26.4648L35.0098-26.4648L23.6816 2.88086C21.9727 7.32422 26.7578 9.76562 29.5898 6.10352ZM32.0312-5.51758L45.1172-32.959L21.2402-32.959L45.0684-64.8926L43.8477-65.5762L30.7617-38.1348L54.6387-38.1348L30.8105-6.20117Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9375-1.07422C64.1113 2.14844 69.3359 2.14844 72.4609-1.07422C75.6348-4.19922 75.6348-9.42383 72.4609-12.5977L14.9902-70.0195C11.7676-73.2422 6.54297-73.2422 3.41797-70.0195C0.292969-66.8457 0.341797-61.6211 3.41797-58.4961Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3066-4.44336C65.625-3.125 67.7734-3.125 69.043-4.44336C70.3613-5.71289 70.3613-7.86133 69.043-9.17969L11.5723-66.6504C10.3027-67.9688 8.05664-67.9688 6.78711-66.6504C5.51758-65.3809 5.51758-63.1836 6.78711-61.9141Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltslash);
export default __webpack_public_path__ + "static/media/bolt.slash.be17802a739f8ed6a384dcf72be3df0a.svg";
export { ForwardRef as ReactComponent };